import { AssignedRating } from "../models/Person/AssignedRating";

export const assignedRatingMapper = (dto: PersonsRatingsDTO) => {
  return new AssignedRating({
    id: dto.assignId,
    person: dto.personId || null,
    rating: dto.ratingId || null,
    program: dto.programId || null,
    testSignoutId: dto.testSignoutId || null,
  });
};
